<template>
  <v-row justify="center">
    <v-col style="max-width: 540px !important">
      <v-row no-gutters align="center" justify="start" v-if="$store.state.payments.retrieveLoader">
        <v-col cols="12">
          <v-boilerplate type="image, article" />
          <v-skeleton-loader />
        </v-col>
      </v-row>
      <v-card min-width="350" v-else>
        <v-card-title class="py-4 text-center" v-if="payment.account.logo">
          <v-spacer />
          <v-sheet rounded outlined>
            <v-responsive class="align-center" :aspect-ratio="1/1">
              <v-sheet class="px-1" width="100">
                <v-img :src="payment.account.logo" width="100%" />
              </v-sheet>
            </v-responsive>
          </v-sheet>
          <v-spacer />
        </v-card-title>
        <v-card-subtitle class="py-4">
          <v-row>
            <v-col class="text-center" cols="12">
              <span class="d-block body-1 text--secondary font-weight-medium">{{payment.description}}</span>
              <span class="d-block body-2 text--secondary font-weight-medium">{{payment.account.name}} <template v-if="payment.customer">para {{payment.customer.name}}</template></span>
              <span class="d-block text-h6 text--secondary font-weight-medium" v-if="payment.status !== 'succeeded'">{{payment.amount | currency(payment.currency)}} {{payment.currency}}  del {{payment.date | date}}</span>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-divider />
        <v-card-text class="px-0 background">
          <template v-if="payment.status === 'succeeded'">
            <v-col class="pt-6 text-center">
              <v-icon large color="primary">mdi-checkbox-marked-circle</v-icon>
              <span class="d-block mt-4 subtitle-1 primary--text font-weight-medium">{{payment.invoice ? 'Factura pagada' : 'Pagado'}}</span>
              <span class="d-block mb-6 subtitle-1 text--secondary font-weight-medium">Pago de {{payment.amount | currency(payment.currency)}} {{payment.currency}} el {{payment.date | date}}</span>
              <v-btn @click="dialogVoucher=true" outlined color="secondary">Comprobante de pago</v-btn>
            </v-col>
          </template>
          <template v-else>
            <template v-if="method === null">
              <v-col class="pt-6 text-center">
                <v-icon color="red" large>mdi-alert</v-icon>
                <span class="d-block mt-2 text-h6 red--text font-weight-medium">No hay métodos de pago disponibles</span>
                <span class="d-block">Contacta a {{payment.account.name}} para coordinar la forma de pago</span>
              </v-col>
            </template>
            <template v-else>
              <v-row class="px-4" no-gutters>
                <v-col cols="12" class="pt-1 pb-5 text-center">
                  <span class="d-block body-2">Elige cómo quieres pagar</span>
                </v-col>
                <v-col cols="12">
                  <v-card>
                    <v-tabs v-model="method" :color="payment.account.color_background" background-color="background" fixed-tabs height="55" slider-size="4">
                      <v-tab class="text-none font-weight-medium" :disabled="!payment.gateways.length"><v-icon left small>mdi-credit-card</v-icon>Pago online</v-tab>
                      <v-tab class="text-none font-weight-medium" :disabled="!payment.account.display_bank_statement || !payment.account.bank_statement"><v-icon left small>mdi-bank</v-icon>Transferencia</v-tab>
                    </v-tabs>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-tabs-items class="transparent" v-model="method">
                    <v-tab-item>
                      <v-row class="mx-0" align="center" justify="start" no-gutters>
                        <v-col cols="12" class="px-0">
                          <v-radio-group class="mt-1 mb-2" v-model="selectedGateway" hide-details>
                            <v-sheet class="overflow-hidden rounded my-2" v-for="gateway in payment.gateways" :key="gateway" outlined>
                              <v-radio class="pl-3 pr-8 py-3" :value="gateway" :color="payment.account.color_background">
                                <template v-slot:label>
                                  <v-row class="pl-3" align="center" justify="space-between">
                                    <img class="ml-4" :src="require(`@/assets/appAsset-brand--${gateway}Logo.svg`)" :alt="gateway" height="32">
                                  </v-row>
                                </template>
                              </v-radio>
                            </v-sheet>
                          </v-radio-group>
                        </v-col>
                        <v-col cols="12" class="px-0" v-if="selectedGateway">
                          <v-btn @click="$router.push({ name: `Gateway${selectedGateway.charAt(0).toUpperCase()}${selectedGateway.slice(1)}` })" :color="payment.account.color_background" dark height="40" block>Continuar</v-btn>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item>
                      <v-row class="mx-0" align="center" justify="start">
                        <v-col cols="12" class="px-0">
                          <v-sheet class="overflow-hidden rounded mt-4 mb-2" outlined>
                            <pre class="pa-5" v-html="payment.account.bank_statement"></pre>
                          </v-sheet>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
              </v-row>
            </template>
          </template>
          <template v-if="payment.invoice">
            <v-toolbar class="mt-5 transparent" flat height="50">
              <v-toolbar-title class="subtitle-2 text--secondary font-weight-medium">Detalle {{payment.invoice.document.name}} Nº {{payment.invoice.number}}</v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Descripción</th>
                    <th class="text-right">Cantidad</th>
                    <th class="text-right">Precio</th>
                    <th class="text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(d, i) in payment.invoice.lines">
                    <tr :key="i">
                      <td><span class="text--secondary font-weight-medium">{{d.name}}</span></td>
                      <td class="text-right">{{d.quantity}}</td>
                      <td class="text-right"><span class="text--secondary font-weight-medium">{{d.amount | currency(payment.currency)}}</span></td>
                      <td class="text-right"><span class="body-2 text--secondary font-weight-medium">{{d.total | currency(payment.currency)}}</span></td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
            <v-divider />
            <!-- summary -->
            <v-row align="center" justify="end">
              <v-col cols="8">
                <v-list class="pa-0 transparent">
                  <v-list-item>
                    <v-list-item-title class="mr-2 text--secondary font-weight-medium">Subtotal</v-list-item-title>
                    <v-list-item-subtitle class="text-right">{{payment.invoice.subtotal | currency(payment.currency)}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item v-if="payment.invoice.discount">
                    <v-list-item-title class="mr-2 text--secondary font-weight-medium">Descuento</v-list-item-title>
                    <v-list-item-subtitle class="text-right">
                      <template v-if="payment.invoice.discount_scheme === '$'">{{payment.invoice.discount | currency(payment.currency)}}</template>
                      <template v-else>{{payment.invoice.discount}} {{payment.invoice.discount_scheme}}</template>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <template v-if="payment.invoice.document.has_taxes_detail">
                    <v-divider class="ml-4 my-2" />
                    <v-list-item>
                      <v-list-item-title class="mr-2 text--secondary font-weight-medium">Exento</v-list-item-title>
                      <v-list-item-subtitle class="text-right">{{payment.invoice.exempt | currency(payment.currency)}}</v-list-item-subtitle>
                    </v-list-item>
                    <template v-if="payment.invoice.document.has_taxes">
                      <v-list-item>
                        <v-list-item-title class="mr-2 text--secondary font-weight-medium">Neto</v-list-item-title>
                        <v-list-item-subtitle class="text-right">{{payment.invoice.amount | currency(payment.currency)}}</v-list-item-subtitle>
                      </v-list-item>
                      <v-divider class="ml-4 my-2" />
                      <v-list-item>
                        <v-list-item-title class="mr-2 text--secondary font-weight-medium">Impuestos ({{payment.invoice.tax_percent}}%)</v-list-item-title>
                        <v-list-item-subtitle class="text-right">{{payment.invoice.tax | currency(payment.currency)}}</v-list-item-subtitle>
                      </v-list-item>
                    </template>
                  </template>
                  <v-divider class="ml-4 my-2" />
                  <v-list-item>
                    <v-list-item-title class="subtitle-1 text--secondary font-weight-medium">Total</v-list-item-title>
                    <v-list-item-subtitle class="text-right subtitle-1 text--secondary font-weight-medium">{{payment.invoice.total | currency(payment.currency)}} {{payment.currency}}</v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <!-- end summary -->
          </template>
        </v-card-text>
      </v-card>
      <piriod-sign />
    </v-col>

    <!-- dialog voucher -->
    <v-dialog v-model="dialogVoucher" v-if="payment.status == 'succeeded' && payment.source" width="480" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Comprobante de pago</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogVoucher=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row no-gutters>
            <v-col cols="12">
              <v-list class="transparent py-6">
                <v-list-item>
                  <v-list-item-title>Método de pago</v-list-item-title>
                  <v-list-item-subtitle><img :src="require(`@/assets/appAsset-brand--${payment.source.gateway}Logo.svg`)" :alt="payment.source.gateway" height="24"></v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>ID transacción</v-list-item-title>
                  <v-list-item-subtitle>{{payment.intent.gateway_id}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Tipo de pago</v-list-item-title>
                  <v-list-item-subtitle><code>{{payment.intent.funding}}</code></v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Fecha de pago</v-list-item-title>
                  <v-list-item-subtitle>{{payment.payment_date | dateTime}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-3">
          <v-spacer />
          <v-btn color="primary">Descargar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog voucher -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import PiriodSign from '@/components/PiriodSign'
export default {
  inject: ['theme'],
  components: {
    PiriodSign,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  mixins: [
    GenericViewMixin
  ],
  data () {
    return {
      dialogVoucher: false,
      method: null,
      selectedGateway: ''
    }
  },
  computed: mapState({
    payment: state => cloneDeep(state.payments.payDetail)
  }),
  created () {
    this.$store.dispatch('payments/RETRIEVE', {
      resource: 'pay',
      id: this.$route.params.id
    })
    .then(() => {
      if (this.payment.gateways.length) {
        this.method = 0
      } else if (!this.payment.gateways.length && this.payment.account.display_bank_statement && this.payment.account.bank_statement) {
        this.method = 1
      }
    })
    .catch((error) => {
      if (error.response.status === 404) {
        this.$router.push({ name: 'PageExpired' })
      }
    })
  }
}
</script>